import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { PiYoutubeLogo } from "react-icons/pi";
import { PiFacebookLogo } from "react-icons/pi";
import { FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
    return (
        <div className="container m-auto w-4/5 py-5">
            <div className="row grid gap-6 grid-cols-1 sm:grid-cols-2 lg:[grid-template-columns:2fr_1fr_1fr_1fr]">
                <div className="ColOne ">
                    <div className="AboutUs">
                        <h4 className="py-2 text-white font-bold">About Us</h4>
                        <p className="text-white">Saptasagar Overseas Export Import, founded by Mr. Niramay Khare in Indore, India, is a rapidly growing global trading company dedicated to delivering high-quality Indian products across international markets.</p>
                    </div>
                    <div className="EmailUs">
                        <h4 className="py-2 text-white font-bold">Email</h4>
                        <Link className='list-item font-semibold text-white focus:outline-none list-none

' to='mailto:kamleaditya@yahoo.com'>kamleaditya@yahoo.com</Link>
                    </div>
                </div>
                <div className="ColTwo">
                    <div className="Services">
                        <h4 className="py-2 text-white font-bold">Services</h4>
                        <ul>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/'>Home</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/About'>About</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/Services'>Services</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white focus:outline-none' to='/Product'>Product</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/Contact'>Contact</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="ColThree">
                    <div className="Services">
                        <h4 className="py-2 text-white font-bold">Main Menu</h4>
                        <ul>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/'>Home</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white focus:outline-none' to='/About'>About</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white focus:outline-none' to='/Services'>Services</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white focus:outline-none' to='/Product'>Product</Link>
                            </li>
                            <li className='mb-3'>
                                <Link className='list-item font-semibold text-white  focus:outline-none' to='/Contact'>Contact</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="ColFour">
                    <div className="FollowUs">
                       <h4 className="py-2 text-white font-bold">Follow Us On</h4>
                       <ul className="flex gap-5">
                        <li className="text-white"><FaInstagram /></li>
                        <li className="text-white"><PiYoutubeLogo /></li>
                        <li className="text-white"><PiFacebookLogo /></li>
                       </ul>
                    </div>
                    <div className='my-3'>
                       <h4 className="py-2 text-white font-bold">Follow Us On</h4>
                       <p className="text-white flex items-center">
                        <span className="mr-3 text-white"><FaMapMarkerAlt /></span>
                        27, Tiwari Nagar, Rajendra Nagar, Indore(M.P) , India
                       </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer;